<!--零碳海洋-->
<template class="ecologicalValue">
  <div style="font-family: Alibaba">
    <!--CP端-->
    <div class="PC_box">
      <!--插入头部-->
      <div>
        <keep-alive>
          <component class="ecological" :is='components.tail'></component>
        </keep-alive>
      </div>

      <!--导航图-->
      <div>
        <el-carousel  style="height: 480px" >
          <el-carousel-item v-for='item in ecologicalList' :key='item.id' style="height: 480px">
<!--            <div @click='jump(item)'>-->
              <el-image
                style="width: 100%;height: 480px"
                v-if='item.fullPathUrl != null'
                :src='item.fullPathUrl'
              />
<!--            </div>-->
          </el-carousel-item>
        </el-carousel>
      </div>

      <!--海上碳循环试验平台标题-->
      <div class='title'>
        <div>
          <h1>
            <i class="el-icon-caret-right"></i>{{ cnNameOne }}
          </h1>
          <p>{{ enNameOne }}</p>
        </div>
      </div>
      <!--海上碳循环试验平台-->
      <div class="Park_img box-width" style="text-align: center;display: block">
        <el-image
          :src="parkIntroduction.fullPathUrl"
        >
        </el-image>
      </div>
      <div class="Park_text box-width">
        <h4>{{ parkIntroduction.title }}</h4>
        <div v-html="parkIntroduction.content" class="htmlImgSize"></div>
<!--        <el-link :underline="false" href="" target="_blank" style="float: right">了解更多...</el-link>-->
      </div>

      <!--园区生态标题-->
      <div class='title'>
        <div>
          <h1>
            <i class="el-icon-caret-right"></i>{{ cnNameTwo }}
          </h1>
          <p>{{ enNameTwo }}</p>
        </div>
      </div>

      <!--园区生态-->
      <el-tabs  class="box-width" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane v-for="(item, index) in ecologicalPark"  :key="item.id" :label="item.name" :name="item.url">
          <el-row :gutter="20" class="carbon">
            <!--图片-->
            <el-col :md="12" :sm="12" :xs="24">
              <div class="tab_img">
                <el-image
                  alt="Image Description"
                  :src="item.fullPathUrl"
                  :fit="fit"></el-image>
              </div>
            </el-col>
            <!--内容-->
            <el-col :md="12" :sm="12" :xs="24">
              <div class="ecology">
                <h4>{{ item.title }}</h4>
                <div v-html="item.content" class="htmlImgSize"></div>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>

      <!--生态价值标题-->
      <div class='title'>
        <div>
          <h1>
            <i class="el-icon-caret-right"></i>{{ cnNameThree }}
          </h1>
          <p>{{ enNameThree }}</p>
        </div>
      </div>
      <!--生态价值-->
      <el-row  :gutter="20" class="box-width Product">
        <el-col v-for="(item, index) in ecologicalValue" :key="item.id" :lg="8" :md="8" :sm="12" :xs="24">
          <el-card shadow="hover" :body-style="{ padding: '0px' }" class="card_box" >
            <el-image
              alt="Image Description"
              :src="item.fullPathUrl"
              :fit="fit"></el-image>
            <div class="text">
              <h4>{{ item.title }}</h4>
              <div v-html="item.content" class="ProductSize"></div>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <!--插入尾部-->
      <div>
        <keep-alive>
          <component  :is='components.tail1'></component>
        </keep-alive>
      </div>
    </div>

    <!--手机端-->
    <div class="mobile_box product">
      <!--插入头部-->
      <div>
        <keep-alive>
          <component :is='components.tail'></component>
        </keep-alive>
      </div>

      <div class='paddingS'>
        <!--占位div-->
        <div style='height: 72px'></div>

        <!--主图-->
        <div class="main_img">
          <el-carousel height="200px" class='carousel_class'>
            <el-carousel-item v-for='item in ecologicalList' :key='item.id'>
              <div>
                <el-image
                  :fit='fit'
                  style="width: 100%"
                  v-if='item.fullPathUrl != null'
                  :src='item.fullPathUrl'
                />
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>

        <!--园区介绍-->
        <div class="boxs_content">
          <div class='title'>
            <!--标题-->
            <div>
              <h1>
                <i class="el-icon-caret-right"></i>
                {{ cnNameOne }}
                <span>{{ enNameOne }}</span>
              </h1>
            </div>
            <!--内容-->
            <div>
              <el-image
                style="width: 100%"
                :fit='fit'
                v-if='parkIntroduction.fullPathUrl != null'
                :src='parkIntroduction.fullPathUrl'
              />
            </div>
            <h4 style="text-align: center;line-height: 30px">{{ parkIntroduction.title }}</h4>
            <div v-html="parkIntroduction.content" class="htmlImgSize"></div>
          </div>
        </div>

        <!--园区生态-->
        <div class="boxs_content">
          <div class='title'>
            <!--标题-->
            <div>
              <h1>
                <i class="el-icon-caret-right"></i>
                {{ cnNameTwo }}
                <span>{{ enNameTwo }}</span>
              </h1>
            </div>
            <!--内容-->
            <div>
              <div v-for="(item, index) in ecologicalPark" :key="item.id">
                <div>
                  <el-image
                    :fit='fit'
                    v-if='item.fullPathUrl != null'
                    :src='item.fullPathUrl'
                  />
                </div>
                <h6>
                  <i class="el-icon-position"></i>
                  {{ item.title }}
                </h6>
                <div v-html="item.content" class="htmlImgSize"></div>
              </div>
            </div>
          </div>
        </div>

        <!--生态价值-->
        <div class="boxs_content">
          <div class='title'>
            <!--标题-->
            <div>
              <h1>
                <i class="el-icon-caret-right"></i>
                {{ cnNameThree }}
                <span>{{ enNameThree }}</span>
              </h1>
            </div>
            <!--内容-->
            <div>
              <div v-for="(item, index) in ecologicalValue" :key="item.id">
                <div>
                  <el-image
                    :fit='fit'
                    v-if='item.fullPathUrl != null'
                    :src='item.fullPathUrl'
                  />
                </div>
                <h6>
                  <i class="el-icon-position"></i>
                  {{ item.title }}
                </h6>
                <div v-html="item.content" class="htmlImgSize"></div>
              </div>
            </div>
          </div>
        </div>

        <!--提交需求-->
        <div class="boxs_content">
          <div class='title'>
            <!--标题-->
            <div>
              <h1>
                <i class="el-icon-caret-right"></i>
                提交需求
                <span>Submit Requirements</span>
              </h1>
            </div>
            <!--form表单-->
            <el-form class="el_form" :model="form" ref="ecologicalRef" :rules="rules">
              <el-form-item prop="unitName">
                <el-input class="consult_inp" placeholder="单位" v-model="form.unitName"></el-input>
              </el-form-item>
              <el-form-item prop="fullName">
                <el-input class="consult_inp" placeholder="姓名" v-model="form.fullName"></el-input>
              </el-form-item>
              <el-form-item prop="phone">
                <el-input class="consult_inp" placeholder="电话" v-model="form.phone"></el-input>
              </el-form-item>
              <el-form-item prop="demand">
                <el-input class="consult_inp" placeholder="需求" type="textarea" v-model="form.demand"></el-input>
              </el-form-item>
              <el-button size="small" type="primary" @click="onSubmit">提 交</el-button>
            </el-form>
          </div>
        </div>

        <!--插入尾部-->
        <div>
          <keep-alive>
            <component  :is='components.tail1'></component>
          </keep-alive>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import header from '../components/header.vue'
import footer from '../components/footer.vue'
import { findBanner, findEnName, findEcologicalOne, findEcologicalTwo, findEcologicalThree, addDemand } from '@/api/zh'

export default {
  data () {
    return {
      tabId: null,
      components: {
        tail: header,
        tail1: footer
      },
      form: {
        name: '',
        phone: '',
        company: '',
        demand: ''
      },
      activeName: '',
      fit: 'cover',
      src: require('@assets/images/index/jnkjy.jpg'),
      url: require('@assets/images/index/chanping.png'),
      url1: require('@assets/images/index/chanping1.png'),
      url2: require('@assets/images/index/chanping2.png'),
      ecologicalList: [],
      carouselParams: {
        type: 1
      },
      enNameOne: '',
      enNameTwo: '',
      enNameThree: '',
      cnNameOne: '',
      cnNameTwo: '',
      cnNameThree: '',
      parkIntroduction: {
        fullPathUrl: '',
        title: '',
        content: ''
      },
      ecologicalPark: [],
      ecologicalValue: [],
      rules: {
        unitName: [{ required: true, message: '请输入单位', trigger: 'blur' }],
        fullName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入电话', trigger: 'blur' }],
        demand: [{ required: true, message: '请输入需求', trigger: 'blur' }]
      }
    }
  },
  created () {
    this.tabId = this.$route.query.tabId
    this.selectBanner()
    this.selectEnName()
  },
  mounted () {
  },
  methods: {
    jump (raw) {
      if (raw.newsId === undefined || raw.newsId === '' || raw.newsId === null) {
      } else {
        this.$router.push({
          path: '/textContent',
          query: {
            id: raw.newsId,
            type: 2
          }
        })
      }
    },
    /** 轮播图 */
    selectBanner () {
      let that = this
      findBanner(this.tabId).then(res => {
        that.ecologicalList = res.data
      })
    },
    /** 查询英文名称 */
    selectEnName () {
      let that = this
      findEnName(this.tabId).then(res => {
        let data = res.data
        that.enNameOne = data[0].enName
        that.cnNameOne = data[0].cnName
        that.selectEcologicalOne(data[0].id)

        that.enNameTwo = data[1].enName
        that.cnNameTwo = data[1].cnName
        that.selectEcologicalTwo(data[1].id)

        that.enNameThree = data[2].enName
        that.cnNameThree = data[2].cnName
        that.selectEcologicalThree(data[2].id)
      }).catch(error => {
        console.error('Error fetching English names:', error)
      })
    },
    selectEcologicalOne (enNameId) {
      let that = this
      findEcologicalOne(enNameId).then(res => {
        that.parkIntroduction = res.data
      })
    },
    selectEcologicalTwo (enNameId) {
      let that = this
      findEcologicalTwo(enNameId).then(res => {
        that.ecologicalPark = res.data
        that.activeName = res.data[0].url
      })
    },
    selectEcologicalThree (enNameId) {
      let that = this
      findEcologicalThree(enNameId).then(res => {
        that.ecologicalValue = res.data
      })
    },
    /** tab */
    handleClick (tab, event) {
      console.log(tab, event)
    },
    onSubmit () {
      let that = this
      this.$refs.ecologicalRef.validate((valid) => {
        if (valid) {
          let params = that.form
          params.tabId = that.tabId
          addDemand(params).then(res => {
            that.$message({
              type: 'success',
              message: res.msg,
              duration: 1000
            })
            that.form = {}
          }).catch(error => {
            console.log('Error submitting form:', error)
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
::v-deep .htmlImgSize img{
  max-width: 100%;
  height: auto;
}
</style>
